var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgSuppliersImport = function SvgSuppliersImport(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 36.027 37.5",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2610"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#265fe0",
    "data-name": "Gruppe 2608"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 2604",
    transform: "translate(2.277 17.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 2.5h3.75v10H15z",
    "data-name": "Rechteck 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5 5h3.75v8.75H27.5z",
    "data-name": "Rechteck 49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.5 2.5h26.75a1 1 0 0 1 1 1v2.75H2.5V3.5a1 1 0 0 1 1-1",
    "data-name": "Rechteck 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5h3.75v8.75H2.5z",
    "data-name": "Rechteck 51"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 52",
    rx: 1,
    transform: "translate(0 12.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 53",
    rx: 1,
    transform: "translate(12.5 12.5)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 8.75,
    height: 7.5,
    "data-name": "Rechteck 54",
    rx: 1,
    transform: "translate(25 12.5)"
  })), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M24.951.206c3.035.7 4.2 2.479 5.651 4.921h-5.651ZM7.217 5.332a.9.9 0 0 1 1.025.957A1.025 1.025 0 0 1 7.22 7.314H1.025a1.025 1.025 0 1 0 0 2.051h9.229a1.025 1.025 0 1 1 0 2.051H1.025a1.025 1.025 0 1 0 0 2.051h2.256v3.076a1.025 1.025 0 0 0 1.025 1.025h2.062a3.931 3.931 0 0 0 7.7 0h10.415a3.931 3.931 0 0 0 7.7 0h1.788A1.025 1.025 0 0 0 35 16.543v-6.152c0-3.009-3.173-3.208-3.176-3.213h-7.9A1.025 1.025 0 0 1 22.9 6.152V0H4.307a1.025 1.025 0 0 0-1.026 1.025v2.256h-1.23a1.025 1.025 0 1 0 0 2.051Zm22.447 10.121a1.88 1.88 0 1 1-3.209 1.329 1.88 1.88 0 0 1 3.209-1.329m-18.115 0a1.88 1.88 0 1 1-3.209 1.329 1.88 1.88 0 0 1 3.209-1.329m0 0"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSuppliersImport);
export default ForwardRef;